import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../core/services/api.service';
import {
	IOperationDetailResponse,
	IOperationListPayload,
	IOperationListResponse,
	IOperationTfaDetailApiResponse,
	IOperationTfaDetailBody,
} from '../models/operations.models';

@Injectable({
	providedIn: 'root',
})
export class OperationsService extends ApiService {
	public list(body: IOperationListPayload): Observable<IOperationListResponse> {
		return this.http.post<IOperationListResponse>(environment.apiUrl + `/operations`, body, {
			headers: this.getHeaders(),
		});
	}

	public detail(id: string): Observable<IOperationDetailResponse> {
		return this.http.get<IOperationDetailResponse>(environment.apiUrl + `/operation/${id}`, {
			headers: this.getHeaders(),
		});
	}

	public tfaDetail(id: number | string): Observable<IOperationTfaDetailBody> {
		return this.http
			.get<IOperationTfaDetailApiResponse>(environment.apiUrl + `/tfa/${id}`, {
				headers: this.getHeaders(),
			})
			.pipe(map((response) => response.data));
	}

	public updateStatus(operationUuid: string, stateUuid: string, reasons?: string): Observable<unknown> {
		return this.http.patch<unknown>(
			environment.apiUrl + `/operation/${operationUuid}/status`,
			{ state_uuid: stateUuid, reasons },
			{
				headers: this.getHeaders(),
			},
		);
	}
}
